import React, { useState } from 'react';
import classnames from 'classnames';
import { Pane, Label, TextInput, IdGen } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import { ModelEditorFactory, ModelTypeSelector } from '@leverege/ui-plugin';
import { Colorizers } from '@leverege/ui-attributes';
import I18N from '@leverege/i18n';
import Model from "../model/CountAggTextViewModel.js";
import S from '../Shared.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.dataViewers.aggregations.CountAggTextViewEditor');
export default function CountAggTextViewEditor(props) {
  const {
    value,
    objectType
  } = props;
  const [ids] = useState(IdGen.createIds('attr', 10));
  let idn = 0;
  const onModelChange = useValueChange(Model, props);
  const hLFont = ModelEditorFactory.create(Model.getHeaderLabelFont(value), {
    eventData: 'setHeaderLabelFont',
    onChange: onModelChange
  });
  const vTFont = ModelEditorFactory.create(Model.getValueTextFont(value), {
    eventData: 'setValueTextFont',
    onChange: onModelChange
  });
  return /*#__PURE__*/_jsxs(Pane, {
    variant: "editor",
    className: classnames(S.grid, S.sub),
    children: [/*#__PURE__*/_jsx("h3", {
      className: S.fill,
      children: t('header')
    }), /*#__PURE__*/_jsx(Label, {
      htmlFor: ids[idn],
      children: t('label')
    }), /*#__PURE__*/_jsx(TextInput, {
      id: ids[idn++],
      eventData: "setHeaderLabel",
      onChange: onModelChange,
      value: Model.getHeaderLabel(value)
    }), /*#__PURE__*/_jsx(Label, {
      htmlFor: ids[idn],
      children: t('variant')
    }), /*#__PURE__*/_jsx(TextInput, {
      id: ids[idn++],
      eventData: "setVariant",
      onChange: onModelChange,
      value: Model.getVariant(value)
    }), /*#__PURE__*/_jsx(Label, {
      variant: "input",
      htmlFor: ids[idn],
      children: t('color')
    }), ModelTypeSelector.createSelectorAndEditor({
      editorProps: {
        ...props,
        id: ids[idn++]
      },
      modelKey: 'colorizer',
      values: Colorizers.getColorizersFor(objectType),
      value: Model.getHeaderLabelColor(value),
      eventData: 'setHeaderLabelColor',
      onChange: onModelChange
    }, S.fill), hLFont != null && /*#__PURE__*/_jsx("div", {
      className: classnames(S.fill, S.sub),
      children: hLFont
    }), /*#__PURE__*/_jsx("h3", {
      className: S.fill,
      children: t('value')
    }), /*#__PURE__*/_jsx(Label, {
      children: "Text"
    }), /*#__PURE__*/_jsx(Label, {
      variant: "input",
      htmlFor: ids[idn],
      children: t('color')
    }), ModelTypeSelector.createSelectorAndEditor({
      editorProps: {
        ...props,
        id: ids[idn++]
      },
      modelKey: 'colorizer',
      values: Colorizers.getColorizersFor(objectType),
      value: Model.getValueTextColor(value),
      eventData: 'setValueTextColor',
      onChange: onModelChange
    }, S.fill), vTFont != null && /*#__PURE__*/_jsx("div", {
      className: classnames(S.fill, S.sub),
      children: vTFont
    })]
  });
}